import React from "react";

export default function FeaturedProjects() {
  return (
    <section className="py-12">
      <h2 className="text-center uppercase font-bold text-[clamp(2rem,3.5vw,4rem)] mb-[20px] font-[Aquarium]">
        featured projects
      </h2>
      <div className="bg-center bg-fixed bg-cover bg-no-repeat h-full flex-col py-10  bg-[linear-gradient(rgba(4,9,30,0.3),rgba(4,9,30,0.5)),url('~/public/images/img-5.webp')]">
        <div className="flex max-w-[90%] container m-auto justify-between rounded-xl bg-white items-center overflow-hidden">
          <div className="flex flex-col lg:w-[70%] px-5">
            <h2 className="text-center text-black uppercase font-bold text-[clamp(2rem,3vw,3rem)]  font-[Aquarium] my-5">
              Tohshka Project
            </h2>
            <p className="text-gray-500  max-lg:text-center text-[18px] max-lg:text-[12px] text-center">
              Toshka Village, Sahara Desert of Egypt Location: New Valley
              Governorate Description: 720,000 thousand Acres, were responsible
              for branch one, and 25 Industrial plant, and the length of the
              canal is 32,400 KM.
            </p>
            <a
              className="text-center m-auto mb-[20px] font-semibold hover:bg-black hover:text-white uppercase max-lg:mx-auto block rounded-[10px] border-2 border-black w-[120px] py-2 mt-6 transition-all"
              href="projects/toshka-village-sahara-desert-of-egypt/toshka"
            >
              View more
            </a>
          </div>
          {/* <div className="bg-[url('~/public/images/imgtoshkahome.webp')] bg-center bg-cover w-[50%] h-[60vh] max-lg:hidden" /> */}
          <div className="flex items-center h-full w-full max-lg:hidden">
            <img
              src="/images/imgtoshkahome.webp"
              alt="toshka"
              className="w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
